/*
  Barra "de volta à peça" da página Sobre (sections/about-return.liquid).
  Spec: docs/superpowers/specs/2026-09-23-about-epica-design.md, S4–S6.

  1. lê localStorage['recently-viewed'] — o tema grava em toda PDP, em
     sections/main-product-cloestar.liquid ([data-recently-viewed]), do mais
     recente para o mais antigo. Sem acesso (janela privada, dados
     bloqueados), não faz nada;
  2. tenta até MAX handles, em ordem, e fica com o primeiro que responde em
     <raiz>/products/<handle>.js E está disponível: peça esgotada não é
     oferecida; <raiz> é window.Shopify.routes.root, para funcionar sob
     /en-ca/ e mercados semelhantes;
  3. preenche por textContent e atributo, nunca innerHTML — o título vem da
     loja e não é markup;
  4. mostra a barra só com a abertura FORA da tela, o fechamento ainda não
     visível E o fechamento não tendo passado por cima da tela: sem o
     terceiro critério, depois que o fechamento sai de vista rolando para
     baixo a barra reaparece e cobre o rodapé para sempre. Rolar de volta
     para cima faz o fechamento sair por baixo de novo, e a barra volta. Sem
     IntersectionObserver, mostra assim que preenche.

  window.aboutReturn.pronto é a Promise do trabalho (handle mostrado ou null):
  é o que scripts/lib/test_about_return.py espera.
*/
(function () {
  var MAX = 3;

  function handles() {
    try {
      return (window.localStorage.getItem('recently-viewed') || '')
        .split(',')
        .map(function (h) { return h.trim(); })
        .filter(Boolean)
        .slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function primeiraDisponivel(lista) {
    if (!lista.length) return Promise.resolve(null);
    return fetch(raiz() + 'products/' + encodeURIComponent(lista[0]) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { return p && p.available ? p : primeiraDisponivel(lista.slice(1)); });
  }

  function preco(centavos) {
    var moeda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: moeda })
        .format(centavos / 100);
    } catch (e) {
      return '';
    }
  }

  function foto(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function preencher(barra, p) {
    barra.querySelector('.about-return__link').setAttribute('href', raiz() + 'products/' + encodeURIComponent(p.handle));
    barra.querySelector('.about-return__title').textContent = p.title || '';
    barra.querySelector('.about-return__price').textContent = typeof p.price === 'number' ? preco(p.price) : '';
    var img = barra.querySelector('.about-return__img');
    var src = foto(p.featured_image);
    if (src) img.setAttribute('src', src);
    else img.remove();
  }

  function vigiar(barra) {
    var abertura = document.querySelector('.about-hero');
    var fechamento = document.querySelector('.about-cta');
    if (typeof window.IntersectionObserver !== 'function' || !abertura) {
      barra.hidden = false;
      return;
    }
    var visivel = { abertura: true, fechamento: false, passou: false };
    var obs = new window.IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.target === abertura) visivel.abertura = e.isIntersecting;
        if (e.target === fechamento) {
          if (e.isIntersecting) {
            visivel.fechamento = true;
          } else {
            // Saiu de vista: se foi para CIMA (top < 0), já passou por
            // completo — a barra fica escondida até rolar de volta para lá.
            visivel.fechamento = false;
            visivel.passou = e.boundingClientRect.top < 0;
          }
        }
      });
      barra.hidden = visivel.abertura || visivel.fechamento || visivel.passou;
    });
    obs.observe(abertura);
    if (fechamento) obs.observe(fechamento);
  }

  function iniciar() {
    var barra = document.querySelector('[data-about-return]');
    if (!barra) return Promise.resolve(null);
    return primeiraDisponivel(handles()).then(function (p) {
      if (!p) return null;
      preencher(barra, p);
      vigiar(barra);
      return p.handle;
    });
  }

  window.aboutReturn = {
    pronto: document.readyState === 'loading'
      ? new Promise(function (ok) {
          document.addEventListener('DOMContentLoaded', function () { ok(iniciar()); });
        })
      : iniciar()
  };
})();
